<script>
  import EButton from '@/components/EButton'
  import { productFilters, educationLevels } from '@/constants/products.module'

  export default {
    components: {
      EButton
    },
    data () {
      return {
        // Built from the shared constants instead of hardcoded query strings.
        // The level name IS the `EXAMEN_ONDERWIJSTYPE` facet value, so it can go
        // straight into the query.
        schoolLevels: educationLevels.map(title => ({
          title,
          link: `/producten?${productFilters.educationType}=${encodeURIComponent(title)}`
        }))
      }
    }
  }
</script>

<template>
  <div class="container px-4 mt-12 mb-6 md:px-8 lg:pb-12">
    <div class=" lg:w-1/2 mx-auto text-center md:px-5 lg:px-0">
      <h2 class="text-2xl md:text-3xl font-bold mb-8">
        Producten per schoolniveau
      </h2>
      <ul class="grid grid-cols-2 md:grid-cols-3 gap-2">
        <li
          v-for="level in schoolLevels"
          :key="level.title"
          class="w-full"
        >
          <nuxt-link :to="level.link">
            <e-button
              type="secondary"
              class="product-level-button"
            >
              {{ level.title }}
              <span class="text-blue-500 flex items-center">
                <q-icon name="chevron-right" />
              </span>
            </e-button>
          </nuxt-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.button {
  @apply justify-between w-full flex;
}

.product-level-button {
  @apply text-1xl font-secondary pb-3 pt-4 leading-none;
}

</style>
